import React, { useState } from 'react';
import { useEffect } from 'react';
import axios from "axios"
import { isAuth } from '../helpers/auth';
import { parseISO } from "date-fns";

const ExportToExcel = ({ idtheme, codetheme, usser }) => {
  const [evaluacion, setEvaluacion] = useState('')
  const [datew, setDatew] = useState('')
  const [dateww, setDateww] = useState('')
  const [data, setData] = useState([])
  const [noww, setDateNow] = useState(new Date())

  useEffect(() => {
    getTask()
  }, []);

  const getTask = async () => {
    fetch(`${process.env.REACT_APP_API_URL}/tasks/test/${idtheme}/${codetheme}/${usser}`)
      .then((response) => response.json())
      .then(async (www) => {
        console.log(www[0], "zzz")

        if (www[0]) {
          setData(www[0])
          setDateww(parseISO(www[0].datee))
          setDatew(parseISO(www[0].dateb))
          setEvaluacion(www[0].note)
        } else { }

      })
  };


  return (
    <>
      {isAuth().rol === '1' ? <div>
        {data.length === 0 ? '' : <div className='text-center font-weight-bold text-info'>
          <>{evaluacion === 0 ? '' : `Crédito ${evaluacion}`}</>
        </div>}
      </div> :
        <div>
          {data.length === 0 ? '' : <div className='text-center font-weight-bold text-info'>
            {datew < noww && noww < dateww ? '' :
              <>{evaluacion === 0 ? '' : `Crédito ${evaluacion}`}</>
            }
          </div>}
        </div>}
    </>
  );
};

export default ExportToExcel